import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { PropTypes } from 'mobx-react';
import Routes from 'modules/app/routes';

import './Breadcrumb.scss';

class Breadcrumb extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  getRoute(data) {
    return Routes.find((item) => {
      const info = {
        exact: true,
        path: item.path
      };

      return matchPath(data, info);
    });
  }

  mountBreadcrumb() {
    const breadcrumb = [];
    let data = window.location.pathname;

    while (data !== '') {
      const route = this.getRoute(data);

      if (!isEmpty(route)) {
        let comp = <li key={route.path}> {route.title} </li>;

        if (data !== window.location.pathname) {
          comp = (
            <li key={route.path}>
              <Link to={route.path}> {route.title} </Link>
            </li>
          );
        }

        breadcrumb.push(comp);
      }

      data = data.substring(0, data.lastIndexOf('/'));
    }

    return breadcrumb.reverse();
  }

  render() {
    const breadcrumb = this.mountBreadcrumb();
    const { className } = this.props;
    const classComponent = classNames('breadcrumb', className);

    return <ul className={classComponent}>{breadcrumb}</ul>;
  }
}

export default Breadcrumb;
